/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateCampaignItemCommand } from '../../models/create-campaign-item-command';
import { CreateCampaignItemResult } from '../../models/create-campaign-item-result';

export interface ApiCampaignsCampaignIdItemsPost$Params {
  campaignId: string;

/**
 * Space to act in. Omit to use the user's default space. Must be a space the user belongs to, otherwise the request is rejected.
 */
  'x-space-id'?: string;
      body?: CreateCampaignItemCommand
}

export function apiCampaignsCampaignIdItemsPost(http: HttpClient, rootUrl: string, params: ApiCampaignsCampaignIdItemsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateCampaignItemResult>> {
  const rb = new RequestBuilder(rootUrl, apiCampaignsCampaignIdItemsPost.PATH, 'post');
  if (params) {
    rb.path('campaignId', params.campaignId, {});
    rb.header('x-space-id', params['x-space-id'], {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CreateCampaignItemResult>;
    })
  );
}

apiCampaignsCampaignIdItemsPost.PATH = '/api/campaigns/{campaignId}/items';
